import api from "./axios";
import { API_ENDPOINTS } from "../constants";
import { logDebug, logError } from "../common/utils/logger";

const normalizeOtpResponseData = (data) => {
  if (data == null) return data;
  if (typeof data === "string") {
    const trimmed = data.trim();
    if (trimmed.startsWith("{") && trimmed.endsWith("}")) {
      try {
        return JSON.parse(trimmed);
      } catch {
        return { raw: data };
      }
    }
    return { message: data };
  }
  return data;
};

export const normalizeOtpIdentifier = (identifier) => {
  const raw = String(identifier ?? "").trim();
  if (!raw) return "";
  if (raw.includes("@")) return raw.toLowerCase();
  const digits = raw.replace(/\D/g, "");
  return digits.length > 10 ? digits.slice(-10) : digits;
};

export const resolvePreferredOtpIdentifier = (params = {}) => {
  const mobile = normalizeOtpIdentifier(params.mobile ?? params.mobileNumber);
  if (mobile) return mobile;
  return normalizeOtpIdentifier(params.email ?? params.emailAddress);
};

export const generateOtp = async (params = {}) => {
  const mobile = normalizeOtpIdentifier(params.mobile ?? params.mobileNumber);
  const email = normalizeOtpIdentifier(params.email ?? params.emailAddress);
  const response = await api.post(API_ENDPOINTS.TERM_JOURNEY_GENERATE_OTP, {
    mobile: mobile || undefined,
    email: email || undefined,
    applicationNumber: params.applicationNumber,
    customerName: params.customerName,
  });
  return normalizeOtpResponseData(response?.data);
};

export const verifyOtp = async (identifier, otp) => {
  try {
    const normalizedIdentifier = normalizeOtpIdentifier(identifier);
    const response = await api.post(API_ENDPOINTS.TERM_JOURNEY_VERIFY_OTP, {
      identifier: normalizedIdentifier,
      otp,
    });
    const normalized = normalizeOtpResponseData(response?.data);
    logDebug("[DropoffRecoveryJourney][verifyOtp] response", {
      identifier: normalizedIdentifier,
      status: response?.status,
      data: normalized,
    });
    return normalized;
  } catch (error) {
    logError("[DropoffRecoveryJourney][verifyOtp] failed", {
      identifier: normalizeOtpIdentifier(identifier),
      status: error?.response?.status,
      data: normalizeOtpResponseData(error?.response?.data),
    });
    throw error;
  }
};
